<template>
  <div id="record">
    <div class="rightContent">
      <div class="tableheader">
        <div style="text-align:right;float:right">
          <el-select @change="getList" v-model="cate" placeholder="图片类型" size="mini" style="margin-right:10px;">
            <el-option key="k0" label="全部" value=""></el-option>
            <el-option key="kk1" label="轮播图" value="1"></el-option>
            <el-option key="kk2" label="横幅广告" value="2"></el-option>
            <el-option key="kk3" label="在线客服" value="3"></el-option>
            <!-- <el-option key="kk4" label="对联广告" value="4"></el-option> -->
          </el-select>
          <!-- <el-select @change="getList" v-model="is_mobile" placeholder="适用设备" size="mini" style="margin-right:10px;">
            <el-option key="k0" label="全部" value=""></el-option>
            <el-option key="k1" label="通用" value="3"></el-option>
            <el-option key="k2" label="手机端" value="2"></el-option>
            <el-option key="k3" label="电脑端" value="1"></el-option>
          </el-select> -->

          <el-button @click="editGoods(false)" class="btn1" type="primary" size="mini">添加图片</el-button>
        </div>
      </div>
      <div class="listBlock">
        <el-table :data="lists" style="width: 100%">
          <el-table-column prop="id" label="ID"></el-table-column>
          <el-table-column label="图片">
            <template slot-scope="scope">
              <el-image :style="scope.row.cate<3?{width: '200px'}:{width: '80px'}" :src="getImageUrl(scope.row.filename)" :preview-src-list="[getImageUrl(scope.row.filename)]"></el-image>
            </template>
          </el-table-column>
          <el-table-column prop="url" label="跳转链接" width="300"></el-table-column>
          <el-table-column label="图片类型">
            <template slot-scope="scope">
              <span v-if="scope.row.cate==1">轮播图</span>
              <span v-else-if="scope.row.cate==2">横幅广告</span>
              <span v-else-if="scope.row.cate==3">在线客服</span>
              <!-- <span v-else-if="scope.row.cate==4">对联广告</span> -->
            </template>
          </el-table-column>
		  <el-table-column prop="lunbotime" label="轮播图切换时间"></el-table-column>
          <!-- <el-table-column label="适用设备">
            <template slot-scope="scope">
              <span v-if="scope.row.is_mobile==1">电脑端</span>
              <span v-else-if="scope.row.is_mobile==2">手机端</span>
              <span v-else-if="scope.row.is_mobile==3">通用</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="ordernu" label="排序编码"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button @click="editGoods(scope.row)" class="btn1" type="primary" size="mini">编辑</el-button>
              <el-button @click="deleteGoods(scope.row.id)" class="btn1" type="primary" size="mini">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog width="40%" :title="imageControllerName" :visible.sync="dialogFormVisible">
      <el-form :model="saveForm">
        <el-form-item label="图片类型" :label-width="formLabelWidth">
          <el-select v-model="saveForm.cate" placeholder="图片类型">
            <el-option key="kk1" label="轮播图(750*240)" value="1"></el-option>
            <el-option key="kk2" label="横幅广告(750*100)" value="2"></el-option>
            <el-option key="kk3" label="在线客服" value="3"></el-option>
            <!-- <el-option key="kk4" label="对联广告" value="4"></el-option> -->
          </el-select>
        </el-form-item>
		<el-form-item v-show="saveForm.cate==1" label="录播切换时间" :label-width="formLabelWidth">
		  <el-input v-model="saveForm.lunbotime" autocomplete="off"></el-input>
		  <span>(切换时间须相同，只取一个时间使用)</span>
		</el-form-item>
        <!-- <el-form-item label="适用设备" :label-width="formLabelWidth">
          <el-select v-model="saveForm.is_mobile" placeholder="适用设备">
            <el-option key="k1" label="通用" value="3"></el-option>
            <el-option key="k2" label="手机端" value="2"></el-option>
            <el-option key="k3" label="电脑端" value="1"></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item label="上传图片" :label-width="formLabelWidth">
          <el-upload class="avatar-uploader" name="name" action="/kaiSrv/vedio/put" :show-file-list="false" :on-success="uploadFileOk" :before-upload="beforeUpload">
            <div v-if="saveForm.filename">
              <img :src="getImageUrl(saveForm.filename)" class="avatar avatar_qr" />
            </div>
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
        <el-form-item label="跳转链接" :label-width="formLabelWidth">
          <el-input v-model="saveForm.url" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="排序顺序" :label-width="formLabelWidth">
          <el-input v-model="saveForm.ordernu" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitSave()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "record",
  data() {
    return {
      doing: false,
      lists: [],
      imageControllerName: '新增轮播图',
      dialogFormVisible: false,
      formLabelWidth: '120px',
      saveForm: {
        cate: '',
		lunbotime: 5,
        filename: '',
        url: '',
        id: '',
        ordernu: 100,
        is_mobile: ''
      },
      cate: '',
      is_mobile: ''
    };
  },
  computed: {},
  created() {
    this.resizedwindow();
    this.getList();
  },
  methods: {
	getImageUrl(filename){
		if(filename.indexOf('http') > -1){
			return filename
		}
		return '/kaiSrv/vedio/get/'+filename
	},
    beforeUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPng = file.type === "image/png";
	  const isGif = file.type === "image/gif";
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG && !isPng && !isGif) {
        this.$message.error('图片格式必须是png或jpg/gif');
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过2M');
      }
      return (isJPG || isPng || isGif) && isLt2M;
    },
    uploadFileOk(res, file) {
      this.saveForm.filename = URL.createObjectURL(file.raw);
      if (res.code == 10000) {
        this.saveForm.filename = res.img_path;
      }
    },
    getList() {
      if (this.doing === true) {
        return false;
      }
      let dataLoadIng = this.openFullScreen()
      this.doing = true;
      let _this = this;
      let data = {
        cate: this.cate,
        is_mobile: this.is_mobile
      }
      this.axios
        .post("/kaiSrv/mgr/imgList", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          if (response.data.code == 0) {
            _this.lists = response.data.list;
          }
          setTimeout(() => {
            dataLoadIng.close()
          }, 500);
        });
    },
    editGoods(data) {
      this.saveForm.filename = '';
      this.saveForm.url = '';
      this.saveForm.id = '';
      this.saveForm.ordernu = '';
      this.saveForm.cate = '';
      this.saveForm.is_mobile = '';
	  this.saveForm.lunbotime = 5;
      if(data){
        this.saveForm.filename = data.filename;
        this.saveForm.url = data.url;
        this.saveForm.id = data.id;
        this.saveForm.ordernu = data.ordernu;
        this.saveForm.cate = data.cate + '';
		this.saveForm.lunbotime = data.lunbotime;
        this.saveForm.is_mobile = data.is_mobile + '';
      }
      this.dialogFormVisible = true;
    },
	deleteGoods(id){
		if (this.doing === true) {
		  return false
		}
		let dataLoadIng = this.openFullScreen()
		this.doing = true
		let _this = this
		this.axios
		  .post("/kaiSrv/mgr/imgDelete", {id: id})
		  .then(function(response) {
		    _this.doing = false
		    _this.getList();
		    setTimeout(() => {
		      dataLoadIng.close();
		    }, 500);
		  });
	},
    submitSave() {
      if (this.doing === true) {
        return false;
      }
      let dataLoadIng = this.openFullScreen();
      this.doing = true;
      let _this = this;
      let data = this.saveForm;
      this.axios
        .post("/kaiSrv/mgr/imgSave", this.formData(data))
        .then(function(response) {
          _this.doing = false;
          _this.dialogFormVisible = false;
          _this.getList();
          setTimeout(() => {
            dataLoadIng.close();
          }, 500);
          console.log(response.data);
        });
    }
  }
};
</script>
<style  lang="scss">
#record {
  .tabs-container {
    .el-card__header {
      padding: 0.0833rem 0.1667rem !important;
    }
    .el-card {
      cursor: pointer;
    }
    .el-card:hover {
      border: $blue 1px solid;
    }
  }
  .el-input__inner {
    width: 2.5rem;
  }
  .codeshearch,
  .codeshearch .el-input__inner {
    width: 1.5rem;
  }
  .el-pagination .el-input__inner {
    width: 0.9rem;
  }
  .codeshearch {
    margin-left: 0.05rem;
    margin-right: 0.02rem;
  }
  .avatar-uploader,
  .el-upload,
  .el-upload--text {
    width: 1.22rem;
    height: 1.2rem;
    display: inline-block;
  }
  .avatar-uploader-icon {
    border: 1px solid #ccc;
  }
}
</style>
<style scoped lang="scss">
#record {
  box-sizing: border-box;
  .rightContent {
    width: calc(100% - 0.32rem);
    height: calc(100% - 0.1667rem);
    display: inline-block;
    background-color: #fff;
    margin-left: 0.1667rem;
    margin-top: 0.1667rem;
    border-radius: 0.05rem;
    .tableheader {
      margin: 0.16rem;
    }
    p.title {
      height: 0.4167rem;
      line-height: 0.4167rem;
      font-size: 0.15rem;
      color: #000;
    }
    .btn2,
    .btn3 {
      padding: 0.0667rem 0.0833rem;
      background-color: #409EFF;
      border: 1px solid #409EFF;
    }
    .listBlock {
      margin: 0.08rem;
    }
    .warncolor {
      color: red;
    }
    .btndel {
      margin-left: 0.1rem;
      height: 0.28rem;
      position: relative;
      top: 0.05rem;
    }
  }
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 1.22rem;
    height: 0.5rem;
    margin-left: 1rem;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409eff;
  }
  .avatar-uploader-icon {
    color: #8c939d;
    width: 1.22rem;
    height: 1.22rem;
    text-align: center;
    line-height: 1.22rem;
    margin-top: 0.08rem;
  }
  .imgblockForLogo {
    width: 1.22rem;
    height: 1.22rem;
    display: inline-block;
    border: 1px solid #ccc;
    margin-top: 0.08rem;
  }
  .avatar {
    width: 1.22rem;
    height: 1.22rem;
    display: block;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/lunbo.vue